module.exports = require("reselect");


//////////////////
// WEBPACK FOOTER
// external "reselect"
// module id = 38
// module chunks = 0